export const makeTenantScopedUri = (me, objectType, id) =>
  `urn:replicon-tenant:${me.tenantSlug}:${objectType}:${id}`;
